export default "__VITE_ASSET__442c6bdc__"